export default __webpack_public_path__ + "static/media/cl17.fc9c12ca.webp";